var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('el-switch',{model:{value:(_vm.data.auto_app_goals),callback:function ($$v) {_vm.$set(_vm.data, "auto_app_goals", $$v)},expression:"data.auto_app_goals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }